package floris.graphics.backoffice.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.materialdesignsystem.components.DsPageLayout
import com.materialdesignsystem.components.sections.OverflowMenu
import com.materialdesignsystem.components.widgets.DsAddFloatingActionButton
import com.materialdesignsystem.components.widgets.FilledIconButtonStyle
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.navigation.open
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import floris.graphics.backoffice.components.sections.FooterSection
import floris.graphics.backoffice.components.sections.Header
import floris.graphics.backoffice.components.sections.NavigationItems
import floris.graphics.backoffice.components.sections.SidePanel
import floris.graphics.core.constants.Res
import floris.graphics.core.extensions.format
import floris.graphics.core.navigation.Navigation
import floris.graphics.core.utils.TokenManager
import kotlinx.browser.window
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px

@Composable
fun PageLayout(
    title: String,
    loginRequired: Boolean = true,
    fabOnClick: (() -> Unit)? = null,
    content: @Composable () -> Unit
) {
    if (loginRequired && !TokenManager.areTokensStillValid()) {
        // Login is required but Tokens are not valid, redirect to the login page
        logout()
        return
    }

    val breakpoint = rememberBreakpoint()
    val overflowMenuOpened = remember { mutableStateOf(false) }
    val sidePanelVisible = breakpoint >= Breakpoint.MD

    DsPageLayout(
        title = Res.String.DocumentTitle.format(title),
        header = {
            if (sidePanelVisible) return@DsPageLayout

            Header { overflowMenuOpened.value = true }
        },
        sidePanel = {
            if (!sidePanelVisible) return@DsPageLayout

            SidePanel()
        },
        overflowMenu = {
            OverflowMenu(logoImage = "/logo.svg", onMenuClosed = { overflowMenuOpened.value = false }) {
                NavigationItems()
            }
        },
        overflowMenuOpened = overflowMenuOpened.value,
        footer = {
            FooterSection()
        },
        content = {
            Box(
                modifier = Modifier.fillMaxSize(),
                contentAlignment = Alignment.TopCenter
            ) {
                content()

                if (fabOnClick != null) {
                    DsAddFloatingActionButton(
                        modifier = Modifier
                            .position(Position.Fixed)
                            .right(if (breakpoint >= Breakpoint.MD) 50.px else 24.px)
                            .bottom(50.px),
                        onClick = fabOnClick,
                        variant = FilledIconButtonStyle
                    )
                }
            }
        }
    )
}

fun logout(doNavigation: Boolean = false) {
    TokenManager.clear()
    if (doNavigation) {
        window.open(Navigation.Screen.Admin.Login.route, OpenLinkStrategy.IN_PLACE)
    }
}
